
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 06/03/2025
 * @update 06/03/2025
 * @file src/components/W17/W17F0091
 */

import Api from "../../../services/api";

export function loadForm(params, cb) {
    return async () => {
        await Api.put('/w17f0091/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadFormOrder(params, cb) {
    return async () => {
        await Api.put('/w17f0091/load-cbo-dropdown', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadExpectedPoint(params, cb) {
    return async () => {
        await Api.put('/w17f0091/load-expected-point', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function onSave(params, cb) {
    return async () => {
        await Api.post('/w17f0091/save', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}